import axios from "./axiosinstance";

const ConversationApi = {
  getConversations: () =>
    axios.get("conversations/get-conversation"),

  getMessages: (conversationId, page = 1, limit = 30) =>
    axios.get(
      `conversations/${conversationId}/messages?page=${page}&limit=${limit}`
    ),

  startConversation: (receiverId) =>
    axios.post("conversations/start", { receiverId }),

  getConversationByLead: (leadId) =>
    axios.get(`conversations/lead/${leadId}`),
};

export default ConversationApi;